import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import {
  HeaderMenu,
  HeaderMenuItem,
} from '@maui/elements'
import { UpgradeIconPill } from '@maui/freemium'
import { useAuthProvider } from '@maui-mf/root'

const exploreRoutes = [
  {
    title: 'Actors',
    path: '/actors',
    requiredEntitlements: ['INTEL_RBI_FUS', 'INTEL_RBI_OPS'],
  },
  {
    title: 'Campaigns',
    path: '/campaigns',
    requiredEntitlements: ['INTEL_RBI_FUS', 'INTEL_RBI_OPS'],
  },
  {
    title: 'Malware and Tools',
    path: '/malware',
    requiredEntitlements: ['INTEL_RBI_FUS', 'INTEL_RBI_OPS'],
  },
  {
    title: 'MITRE ATT&CK',
    path: '/mitreattack',
    requiredEntitlements: ['INTEL_RBI_FUS', 'INTEL_RBI_OPS'],
  },
  {
    title: 'Vulnerabilities',
    path: '/vulnerabilities',
    requiredEntitlements: ['INTEL_RBI_VULN'],
  },
]

// TODO stopgap dumb solution until we come up with cross MFE access rules
// TODO share across apps, this is copied over from app-explore-pages
const hasEntitlements = (neededEntitlements, userEntitlements) => {
  if (!neededEntitlements?.length) {
    return true
  }
  if (!userEntitlements?.length) {
    return false
  }
  return neededEntitlements.some(
    entitlement => userEntitlements.includes(entitlement)
  )
}

export const ExploreMenu = () => {
  const { claims } = useAuthProvider()
  const location = useLocation()
  const active = !!location.pathname.match(/^\/(actors|malware|mitreattack|cve)/)

  return (
    <HeaderMenu
      label="Explore"
      active={active}
    >
      {exploreRoutes.map((route, index) =>
        <HeaderMenuItem
          key={index}
          as={NavLink}
          to={route.path}
        >
          {route.title}
          {!hasEntitlements(route.requiredEntitlements, claims?.isl || []) && (
            <UpgradeIconPill variant="icon" />
          )}
        </HeaderMenuItem>
      )}
    </HeaderMenu>
  )
}
